module.exports = __webpack_public_path__ + "static/fipcwhiteabc1-f3ec748870d48e6c41e759aca9e5a744.jpeg";